// AUTOGENERATED from admin Language.bcp47 on 2026-09-11
// 2329 entries (1 admin rows skipped — missing or malformed slug/bcp47).
// Regenerate via: pnpm --filter @forge/web generate:language-bcp47-map
// Drift check:    pnpm --filter @forge/web check:language-bcp47-map
// (.github/workflows/watch-language-corpus-drift.yml runs it on a schedule).
//
// Maps the English-name kebab slug (admin Language.slug) used in /watch
// URLs to admin's full BCP-47 tag. Consume via
// slugToBcp47Primary() in lib/locale.ts — that helper extracts the
// primary subtag (es-ES → es) for the generated UI-catalog fallback chain.
//
// The runtime route classifier and the watch content identity in
// lib/content.ts also admit audio slugs from the live Watch route
// manifest, so a stale copy of this file degrades <html lang> and UI
// chrome for a new language — it must not 404 its URL or play English.

export const LANGUAGE_BCP47_MAP: Readonly<Record<string, string>> =
  Object.freeze({
    "a-hmao": "hmd",
    aari: "aiw",
    abanglekuo: "bzy",
    abanyom: "abm",
    abau: "aau",
    abidji: "abi",
    abkhaz: "abk",
    abure: "abu",
    abureni: "mgj",
    acateco: "knj",
    acchami: "npi",
    aceh: "ace",
    achang: "acn",
    ache: "yif",
    "ache-2": "guq",
    "achi-rabinal": "acr",
    acholi: "ach",
    "achuar-shiwiar": "acu",
    adangme: "ada",
    adele: "ade",
    adi: "adi",
    adioukrou: "adj",
    adonara: "adr",
    adygey: "ady",
    adzera: "adz",
    afar: "aa",
    afrikaans: "af",
    agabag: "sbr",
    agarabi: "agd",
    agatu: "agc",
    aghem: "agq",
    aguna: "aug",
    "agusan-surigao-manobo": "msm",
    ahanta: "aha",
    ahirani: "ahr",
    aikana: "tba",
    "aja-gbe": "ajg",
    ajiya: "idc",
    akebu: "keu",
    akeu: "aeu",
    akha: "ahk",
    aklanon: "akl",
    akoose: "bss",
    akposo: "kpo",
    akuku: "ayk",
    alaba: "alw",
    alagwa: "wbj",
    alangan: "alj",
    albanian: "sq",
    "albanian-kosovar": "sq-aln",
    "ale-gawwada": "gwd",
    "alis-i-ron": "cla",
    altai: "alt",
    alur: "alz",
    ama: "nyi",
    amam: "bcu",
    amanab: "amn",
    "ambae-east": "omb",
    ambai: "amk",
    "ambrym-southeast": "tvk",
    "amdo-tibetan": "adx",
    "american-sign-language": "ase",
    amharic: "am",
    "amuzgo-guerrero": "amu",
    "amuzgo-oaxaca": "azg",
    anaang: "anw",
    andaandi: "dgl",
    andio: "bzb",
    angaataha: "agm",
    "angal-heneng": "akh",
    angika: "anp",
    anjam: "boj",
    ansus: "and",
    antandroy: "mg-tdx",
    antesaka: "tkg",
    anuak: "anu",
    anufo: "cko",
    anyin: "any",
    ao: "njo",
    aokha: "ema",
    apalai: "apy",
    apinaye: "apn",
    apurina: "apu",
    "arabic-algerian-spoken": "ar-arq",
    "arabic-bedouin": "avl",
    "arabic-chadian-spoken": "ar-shu",
    "arabic-egyptian-colloquial": "ar-arz",
    "arabic-gulf": "ar-afb",
    "arabic-hassaniya": "ar-mey",
    "arabic-hijazi": "acw",
    "arabic-iraqi-baghdadi": "ar-acm",
    "arabic-juba": "pga",
    "arabic-khuzestani": "acm",
    "arabic-libyan": "ar-ayl",
    "arabic-modern-standard": "ar",
    "arabic-modern-standard-egyptian": "ar-arb-EG",
    "arabic-modern-standard-sharif": "ar-arb",
    "arabic-moroccan-spoken": "ar-ary",
    "arabic-najdi": "ars",
    "arabic-north-african": "ar-aao",
    "arabic-palestinian": "ar-ajp",
    "arabic-saidi-spoken": "ar-aec",
    "arabic-sanaani": "ayn",
    "arabic-sudanese-spoken": "ar-apd",
    "arabic-taizzi-yemeni": "ar-acq",
    "arabic-tunisian": "ar-aeb",
    aralle: "atq",
    aramba: "stk",
    arbore: "arv",
    are: "mwc",
    arhe: "atg",
    "arifama-miniafia": "aai",
    aringa: "luc",
    armenian: "hy",
    "armenian-western": "hy-arevmda",
    arosi: "aia",
    arumanian: "rup",
    "asante-twi": "aka",
    ashaninka: "cni",
    "asheninca-pichis": "cpu",
    assamese: "as",
    "assamese-muslim": "asm",
    assyrian: "aii",
    ateso: "teo",
    athpariya: "aph",
    "atitlan-mixe": "neq",
    auhelawa: "kud",
    aukaans: "djk",
    avar: "av",
    avikam: "avi",
    avokaya: "avu",
    awa: "vwa",
    "awa-8": "awb",
    "awa-cuaiquer": "kwi",
    "awad-bing": "bcu",
    awadhi: "awa",
    "awadhi-nepal": "awa",
    awajun: "agr",
    awak: "awo",
    awgni: "awn",
    awing: "azo",
    awutu: "afu",
    "ayizo-2": "ayb",
    "ayizo-tori": "ayb",
    "aymara-central": "ayr",
    ayoreo: "ayo",
    "ayta-abellen": "abp",
    "ayta-ambala": "abc",
    "ayta-mag-antsi": "sgb",
    "ayta-mag-indi": "blx",
    "azerbaijani-iran": "azb",
    "azerbaijani-north": "azj",
    azha: "aza",
    "aztec-nahuatl-guerrero": "ngu",
    babanki: "bbk",
    "bacama-bwatiye": "bcy",
    bada: "bhz",
    badaga: "bfq",
    bade: "bde",
    "bado-parja": "bdv",
    baeggu: "bvd",
    baelelea: "bvc",
    bafut: "bfd",
    bagheli: "bfy",
    bagri: "bgq",
    "bahasa-melayu-2": "zlm",
    bahnar: "bdq",
    bai: "bca",
    "bai-lama": "lay",
    "bai-southern": "bfs",
    baiso: "bsw",
    baitadeli: "npi",
    "bajau-indonesian": "bdl",
    bajhangi: "npi",
    bajureli: "npi",
    baka: "bdh",
    bakairi: "bkq",
    bakhtiari: "bqi",
    bakumpai: "bkr",
    bakwe: "bjw",
    balangao: "blw",
    "balangin-indo": "knx",
    balanta: "ble",
    "balanta-ganja": "bjt",
    "balanta-naga": "ble-x-Naga",
    balantak: "blz",
    bali: "ban",
    "bali-madya": "ban",
    balkar: "krc",
    "balochi-eastern": "bgp",
    "balochi-southern": "bcc",
    "balochi-western": "bgn",
    balti: "bft",
    bambam: "ptu",
    bambara: "bm",
    bamu: "bcf",
    bamun: "bax",
    bana: "bcw",
    "banda-linda": "liy",
    bandi: "bza",
    bandial: "bqj",
    banggai: "bgz",
    bangi: "bni",
    bangjinge: "bsj",
    bangka: "mfb",
    "bangla-2": "bn",
    "bangla-muslim": "bn-BD",
    banjar: "bjn",
    bankagooma: "bxw",
    bantoanon: "bno",
    bara: "bhr",
    "bara-tharu": "thq",
    barai: "bbb",
    "bareli-pawri": "bfb",
    "bareli-rathwi": "bgd",
    bari: "bfa",
    bariai: "bch",
    bariba: "bba",
    barka: "bib",
    basa: "bzw",
    basaa: "bas",
    basang: "bzy",
    bashkir: "ba",
    basketto: "bst",
    basque: "eu",
    bassa: "bsq",
    "batak-alas": "btz",
    "batak-angkola": "akb",
    "batak-karo": "btx",
    "batak-kluet": "btz",
    "batak-mandailing": "btm",
    "batak-simalungun": "bts",
    "batak-toba": "bbc",
    bateq: "btq",
    batui: "zbt",
    baule: "bci",
    bauria: "bge",
    bawean: "mad",
    bazigar: "bfr",
    bedamuni: "beo",
    beembe: "beq",
    behoa: "bep",
    "beja-bidhaawyeet": "bej",
    bekwarra: "bkv",
    bekwel: "bkw",
    bel: "gdd",
    "belanda-viri": "bvi",
    belleh: "blh",
    belorussian: "be",
    bemba: "bem",
    bembe: "bmb",
    bena: "bez",
    benabena: "bef",
    bench: "bcq",
    "bende-tongwe": "bdp",
    "bengali-indian": "bn",
    benyadu: "byd",
    berom: "bom",
    betawi: "bew",
    "bete-daloa": "bev",
    "bete-gagnoa": "btg",
    "bete-guiberoua": "bet",
    bette: "btt",
    bhadrawahi: "bhd",
    bharia: "bha",
    bhatri: "bgw",
    bhattiyali: "bht",
    bhele: "bhy",
    bhilali: "bhi",
    bhili: "bhb",
    bhogoto: "bdt",
    bhojpuri: "bho",
    "bhojpuri-nepal": "bho",
    biafada: "bif",
    biak: "bhw",
    bicolano: "bcl",
    "bidayuh-jagoi": "sne",
    bijago: "bjg",
    "bikol-buhinon": "ubl",
    bilaspuri: "kfs",
    bilua: "blb",
    bima: "bhp",
    bimin: "bhl",
    bimoba: "bim",
    binandere: "bhg",
    bine: "bon",
    binukid: "bkd",
    birifor: "bfo",
    "birifor-southern": "biv",
    bishnupriya: "bpy",
    bislama: "bi",
    bisu: "bzi",
    "blaan-koronadal": "bpr",
    "blaan-sarangani": "bps",
    blackfoot: "bla",
    blang: "blr",
    blin: "byn",
    blowo: "dnj",
    bobe: "bvb",
    "bobo-madare-southern": "bwq",
    bodo: "brx",
    bogghom: "bux",
    bokyi: "bky",
    bola: "bnp",
    bolewa: "bol",
    bolinao: "smk",
    bomu: "bmq",
    bongo: "bot",
    bora: "boa",
    "borna-shinasha": "bwo",
    bororo: "bor",
    bosnian: "bs",
    bouyei: "pcc",
    "bouyei-anshun": "pcc",
    "bouyei-qianxi": "pcc",
    "bozo-jenaama": "bze",
    "bozo-tigemaxo": "boz",
    brahui: "brh",
    "braj-bhasha": "bra",
    "brazilian-sign-language": "bzs",
    brezhoneg: "br",
    "bru-eastern": "bru",
    "bru-van-kieu": "bru",
    "budu-koya": "buu-x-Koya",
    "budu-nita": "buu-x-Nita",
    budza: "bja",
    bugis: "bug",
    "bugis-soppeng": "bug",
    bugkalot: "ilk",
    buglere: "sab",
    bukharian: "bhh",
    buksa: "tkb",
    bukusu: "bxk",
    bulgarian: "bg",
    buli: "bwu",
    bulu: "bum",
    bulusu: "bqr",
    bum: "bmv",
    "bundel-khandi": "bns",
    bungu: "wun",
    buol: "blf",
    "bura-pabir": "bwr",
    "buriat-russia": "bxr",
    burmese: "my",
    "burmese-common": "mya",
    "burmese-musselmani": "my",
    "burmese-standard": "mya",
    burun: "bdi",
    burunge: "bds",
    burushaski: "bsk",
    buurak: "bys",
    "bwamu-laa-laa": "bwj",
    bwazza: "mbu",
    cabecar: "cjp",
    "cakchiquel-central": "cak",
    "cakchiquel-eastern": "cak",
    "cakchiquel-south-central": "cak",
    "cakchiquel-western": "cak",
    canela: "ram",
    cantonese: "yue",
    capanahua: "kaq",
    "carib-eastern": "car-x-Eastern",
    "catalan-valencian-balear": "ca",
    cebuano: "ceb",
    "central-asian-russian": "ru-143",
    "central-buang": "bzh",
    cerma: "cme",
    chachi: "cbi",
    chakfem: "cky",
    chakma: "ccp",
    chaldean: "cld",
    "cham-eastern": "cjm",
    "cham-western": "cja",
    chamacoco: "ceg",
    chamari: "cdg",
    "chamba-daka": "ccg",
    chambeali: "cdh",
    chamling: "rab",
    chamorro: "ch",
    chara: "cra",
    "chasu-pare": "asa",
    "chatgaya-chittagonian-hindu": "ctg",
    "chatgaya-chittagonian-muslim": "ctg",
    "chatino-nopala": "cya",
    "chatino-zenzontepec": "czn",
    chavacano: "cbk",
    chechen: "ce",
    "cheke-holo": "mrn",
    cherepon: "cpn",
    chhattisgarhi: "hne",
    "chibi-setentrional": "rmq",
    chichewa: "ny",
    chikunda: "kdn",
    chilcotin: "clc",
    "chin-asho": "csh",
    "chin-falam": "cfm",
    "chin-khumi": "cnk",
    "chin-mun": "mwq",
    "chin-paite": "pck",
    "chinantec-usila": "cuc",
    "chinanteco-quiotepec": "chq",
    "chinanteco-tepetotutla": "cnt",
    "chinanteco-tlacoatzintepec": "ctl",
    "chinese-guiliu": "zh-x-Guiliu",
    "chinese-hokkien-amoy": "nan",
    "chinese-qinghai": "cmn",
    "chinese-sichuan": "zh-CN-51",
    "chinese-simplified": "zh-hans",
    "chinese-traditional": "zh-hant",
    "chinese-yunnan-kunming": "zh-CN-53-x-Kunming",
    chingoni: "xnj",
    chitembo: "tbt",
    "chitwan-tharu": "the",
    chodri: "cdi",
    "chokwe-angola": "cjk",
    "chokwe-congo": "cjk-CD",
    "chol-tumbala": "ctu",
    chonyi: "coh",
    chopi: "cce",
    chumburung: "ncu",
    churahi: "cdj",
    chuukese: "chk",
    chuvash: "cv",
    chwabo: "chw",
    "cia-cia": "cia",
    cirebon: "jv-x-Cirebon",
    cishingini: "asg",
    clela: "dri",
    cofan: "con",
    cogui: "kog",
    col: "liw",
    "colombian-sign-language": "csn",
    "comorian-shingazidja": "zdj",
    "cook-islands-maori": "rar",
    cora: "crn",
    "costa-rican-sign-language": "csr",
    "cree-western": "crk",
    "crimean-tatar": "crh",
    "crioulo-upper-guinea": "pov",
    croatian: "hr",
    csango: "hu",
    cubeo: "cub",
    "cuicateco-tepeuxila": "cux",
    cun: "cuq",
    curripaco: "kpc",
    cuyonon: "cyo",
    czech: "cs",
    daani: "bmq",
    daasanach: "dsh",
    daba: "dbq",
    dadeldhureli: "dty",
    dadiya: "dbd",
    "dagaari-northern": "dgi",
    "dagaari-southern": "dga",
    dagara: "dga",
    dagbanli: "dag",
    dan: "dnj",
    "dangali-tharu": "thl",
    dangi: "dhn",
    "dani-western": "dnw",
    danish: "da",
    dano: "aso",
    darchuleli: "npi",
    dargin: "dar",
    dari: "prs",
    "dari-4": "der",
    datooga: "tcc",
    daur: "dta",
    "davik-kui": "dwk",
    dawro: "dwr",
    "dayak-ngaju": "nij",
    daza: "dzg",
    deccani: "dcc",
    deg: "mzw",
    dei: "dee",
    "dendi-djougou": "ddn",
    "dendi-malanville": "ddn",
    dene: "chp",
    deori: "der",
    dera: "kna",
    "dersim-zazaki": "kiu",
    desia: "dso",
    dhatki: "mki",
    dhimal: "dhi",
    dhivehi: "dv",
    dhodia: "dho",
    dhopadhola: "adh",
    dhundari: "dhd",
    dibali: "bcp",
    "dida-yocoboue": "gud",
    didinga: "did",
    "digaro-mishmi": "mhu",
    digo: "dig",
    "dijim-cham": "cfa",
    dimasa: "dis",
    dime: "dim",
    "dinka-agar-bor": "dib",
    "dinka-northeastern-padang": "dip",
    "dinka-rek": "dik",
    dirasha: "gdl",
    ditammari: "tbz",
    "djola-bayote": "bda",
    "dogon-jamsay": "djm",
    "dogon-mombo": "dmb",
    "dogon-togo-kan": "dtk",
    "dogon-tommo-so": "dto",
    "dogon-tomo-kan": "dtm",
    "dogon-toro-so": "dts",
    dogose: "dos",
    dogri: "dgo",
    dolpo: "dre",
    dom: "rmt",
    "dong-northern": "doc",
    "dong-southern": "kmc",
    dongissa: "ktb",
    dongnu: "bwx",
    dongo: "doo",
    dongxiang: "sce",
    doondo: "dde",
    "doromu-koki": "kqc",
    "doti-doteli": "dty",
    duala: "dua",
    dubli: "dub",
    "dulangan-manobo": "mta",
    duna: "duc",
    dungan: "dng",
    "dungra-bhil": "duh",
    duri: "mvp",
    duruma: "dug",
    duruwa: "pci",
    dusun: "dtp",
    dutch: "nl",
    duya: "ldb",
    dzongkha: "dz",
    "eastern-garame": "acz",
    "eastern-poqomchi": "poh",
    ebira: "igb",
    ebrie: "ebr",
    eda: "kad",
    "ede-cabe": "cbj",
    "ede-ica": "ica",
    edo: "bin",
    efik: "efi",
    eggon: "ego",
    ehugbo: "ig",
    "ejagham-western": "etu",
    ekajuk: "eka",
    ekpari: "ekr",
    ellomwe: "lon",
    "embera-catio": "cto",
    "embera-northern": "emp",
    embu: "ebu",
    ende: "end",
    enga: "enq",
    enggano: "eno",
    english: "en",
    "english-african": "eng",
    "english-british": "eng",
    "english-north-american-indigenous": "en-nai",
    "enlhet-2": "enl",
    enrekang: "ptt",
    enuani: "ibo",
    enwan: "env",
    enxet: "enx",
    erei: "yay",
    erzya: "myv",
    ese: "mcq",
    "ese-ejja": "ese",
    "eshira-2": "swj",
    estonian: "et",
    "etsako-iyekhe": "ets",
    etulo: "utr",
    "ewage-notu": "nou",
    ewe: "ee",
    ewondo: "ewo",
    ezaa: "eza",
    "fa-dambu": "fab",
    fakai: "gel",
    "fali-north": "fli",
    "fali-south": "fkk",
    fanakalo: "fng",
    fanamaket: "bjp",
    "fang-equatorial-guinea": "fan",
    "fang-gabon": "fan-GA",
    fante: "fat",
    faroese: "fo",
    "farsi-western": "fa",
    fataleka: "far",
    "fernando-po-creole-english": "fpe",
    "fiji-hindi": "hif",
    fijian: "fj",
    finallig: "ebk",
    finnish: "fi",
    flemish: "nld",
    folopa: "ppo",
    "fon-gbe": "fon",
    foochow: "cdo",
    fordata: "frd",
    fore: "for",
    french: "fr",
    "french-african": "fra",
    fulacunda: "fuc",
    "fulfulde-adamawa": "fub",
    "fulfulde-bagirmi": "fui",
    "fulfulde-benin-togo": "fue",
    "fulfulde-caka-nigeria": "fuv",
    "fulfulde-jelgoore": "fuh",
    "fulfulde-maasina": "ffm",
    "fulfulde-pulaar": "fuc-x-Fulfulde",
    "fulfulde-western-niger": "fuh",
    fur: "fvr",
    furu: "fuu",
    "fuuta-jalon": "fuf",
    fwe: "fwe",
    ga: "gaa",
    gaanda: "gqa",
    "gadaba-mudhili": "gau",
    gaddang: "gad",
    gaddi: "gbk",
    gadsup: "gaj",
    "gaelic-irish": "ga",
    "gaelic-scots": "gd",
    gagauz: "gag",
    gagu: "ggu",
    "gaita-koitor": "fmu",
    galela: "gbi",
    galician: "gl",
    galo: "adl",
    gamai: "ank",
    gamit: "gbl",
    gamo: "gmv",
    gangam: "gng",
    gao: "gga",
    "garasia-adiwasi": "gas",
    "garasia-rajput": "gra",
    garhwali: "gbm",
    garifuna: "cab",
    garo: "grt",
    gata: "gaq",
    "gaviao-do-jiparana": "gvo",
    gavva: "gdf",
    gawri: "gwc",
    gayil: "gyl",
    gayo: "gay",
    gbagyi: "gbr",
    gbanu: "gbv",
    gbari: "gby",
    "gbaya-kresh-south-sudan": "krs",
    "gbaya-northwest": "gya",
    "gbaya-southwest": "gso",
    "gbe-saxwe": "sxw",
    "gbe-tofin": "tfi",
    "gbe-weme": "wem",
    gbeya: "gbp",
    gbii: "ggb",
    ge: "hmj",
    gedeo: "drs",
    gela: "nlg",
    "gen-gbe": "gej",
    georgian: "ka",
    gepo: "ygp",
    "german-pennsylvania": "pdc",
    "german-standard": "de",
    ghari: "gri",
    ghomala: "bbj",
    ghotuo: "ikh",
    giangan: "bgi",
    gibaio: "kiw",
    gichuka: "cuh",
    gidar: "gid",
    gikyode: "acd",
    gilaki: "glk",
    "gilaki-rashti": "glk",
    giryama: "nyf",
    gisir: "swj",
    gitonga: "toh",
    "giziga-south": "giz",
    glavda: "glw",
    "goan-konkani": "gom",
    godie: "god",
    gofa: "gof",
    gogo: "gog",
    goji: "kuh",
    gojri: "gju",
    gokana: "gkn",
    gola: "gol",
    golin: "gvf",
    "gondi-aheri": "esg",
    "gondi-northern": "gno",
    gonja: "gjn",
    gorontalo: "gor",
    gourmanchema: "gux",
    gowlan: "goj",
    gowli: "gok",
    "grebo-northern": "gbo",
    greek: "el",
    guahibo: "guh",
    guajajara: "gub",
    guambiano: "gum",
    "guarani-bolivian-eastern": "gui",
    "guarani-mbya": "gun",
    "guarani-paraguayan": "gug",
    "guarani-western-bolivian": "gnw",
    guaymi: "gym",
    "guere-central": "gxx",
    "guhu-samane": "ghs",
    "guina-ang-kalinga": "knb",
    gujarati: "gu",
    guji: "gax",
    "gun-gbe": "guw",
    gungu: "rub",
    "gurage-sodo": "gru",
    "gurage-west": "sgw",
    gurenne: "gur",
    gurgula: "ggg",
    guro: "goa",
    gurung: "gvr",
    gusii: "guz",
    "gutob-gadaba": "gbj",
    "guyanese-creole": "gyn",
    gwere: "gwr",
    gyaazi: "gji",
    hadiyya: "hdy",
    hadothi: "hoj",
    hadza: "hts",
    hainanese: "nan-CN-46",
    "haitian-creole": "ht",
    hajong: "haj",
    hakhun: "nst",
    hakka: "hak",
    halang: "hal",
    halbi: "hlb",
    halia: "hla",
    "hamer-banna": "amf",
    hamgyongdo: "ko-x-Hamgyongdo",
    hanga: "hag",
    "hani-haya": "hni",
    "haniq-beeqhongq": "how",
    hano: "lml",
    hanunoo: "hnn",
    harari: "har",
    haryanvi: "bgc",
    hatam: "had",
    hausa: "ha",
    havu: "hav",
    "hawaii-pidgin": "hwc",
    "hawaiian-nihau": "haw",
    haya: "hay",
    hazaragi: "haz",
    hdi: "xed",
    hebrew: "he",
    hehe: "heh",
    heiban: "hbn",
    "heiyi-zhuang-minz": "zgm",
    hema: "nix",
    hemba: "hem",
    herero: "hz",
    higgi: "hig",
    hiligaynon: "hil",
    hindi: "hi",
    "hindi-caribbean": "hns",
    "hindko-northern": "hno",
    "hindko-southern": "hnd",
    "hiri-motu": "ho",
    hixkaryana: "hix",
    "hlai-has": "lic",
    hmar: "hmr",
    "hmong-daw": "mww",
    "hmong-shuad": "hmz",
    ho: "hoc",
    hona: "hwo",
    "horned-miao": "hrm",
    hote: "hot",
    hrangkhol: "hra",
    hre: "hre",
    "huasteco-san-luis-potosi": "hus-MX-SLP",
    "huasteco-veracruz": "hus",
    "huave-san-mateo-del-mar": "huv",
    huba: "hbb",
    hui: "czh",
    huichol: "hch",
    "huitoto-murui": "huu",
    huli: "hui",
    hunde: "hke",
    hungana: "hum",
    hungarian: "hu",
    hunsrik: "hrx",
    hyam: "jab",
    "ibaas-icen": "cen",
    ibaloi: "ibl",
    iban: "iba",
    ibanag: "ibg",
    ibibio: "ibb",
    icelandic: "is",
    ichen: "ich",
    icheve: "bec",
    idaasha: "idd",
    "idioma-wanca": "qvw",
    idoma: "idu",
    ife: "ife",
    "ifugao-amganad": "ifa",
    "ifugao-mayoyao": "ifu",
    igala: "igl",
    igbo: "ig",
    igede: "ige",
    igiha: "haq",
    ika: "ikk",
    ikhin: "ikh",
    ikizu: "ikz",
    ikoma: "ntk",
    ikota: "koq",
    ikpeshi: "ikp",
    ikwo: "iqw",
    ila: "ilb",
    ilchamus: "saq",
    "ile-ape": "ila",
    ilocano: "ilo",
    imbongu: "imo",
    "indonesian-isa": "id",
    "indonesian-yesus": "id",
    ingush: "inh",
    "inner-mongolian": "mvf",
    innu: "moe",
    inonhan: "loc",
    inor: "ior",
    "inuktitut-eastern-canadian": "ike",
    ipili: "ipi",
    ipunu: "puu",
    iranun: "ilp",
    "iranun-eastern": "ilp",
    "iranun-western": "ilp",
    iraqw: "irk",
    iraya: "iry",
    irula: "iru",
    isan: "tts",
    isangu: "snq",
    ishinyiha: "nih",
    isnag: "isd",
    isoko: "iso",
    italian: "it",
    itawis: "itv",
    iten: "etx",
    itsekiri: "its",
    ivatan: "ivv",
    "ixil-nebaj": "ixl",
    iyaa: "iyx",
    iyansi: "yns",
    izere: "izr",
    izii: "izz",
    "jacalteco-western": "jac",
    jadgali: "jdg",
    jakun: "jak",
    "jama-mapun": "sjm",
    "jamaican-patwa": "jam",
    jaminawa: "yaa",
    japanese: "ja",
    "japanese-sign-language": "jsl",
    jar: "jgk",
    jaruara: "jaa",
    jaunsari: "jns",
    javanese: "jv",
    "javanese-banten": "jv-ID-BT",
    "javanese-banyumasan": "jav",
    "javanese-caribbean": "jvn",
    jeh: "jeh",
    jenjo: "jen",
    jere: "jer",
    jiamao: "jio",
    jibu: "jib",
    jingpho: "kac",
    jita: "jit",
    jju: "kaj",
    "jola-felupe": "eja",
    "jola-fogny": "dyo",
    "jola-kasa": "csk",
    jorai: "jra",
    "jordanian-sign-language": "jos",
    juang: "jun",
    jukun: "juk",
    jula: "dyu",
    "juni-kuin": "cbs",
    "jur-beli": "blm",
    "jur-modo": "bex",
    juray: "juy",
    kaakye: "kye",
    kaba: "ksp",
    "kaba-naa-sara": "kwv",
    kabardian: "kbd",
    "kabeverdiane-barlavente": "kea-CV-B",
    kabiye: "kbp",
    "kabuverdianu-sotaventu": "kea",
    kabwa: "cwa",
    kabyle: "kab",
    kachchhi: "kfr",
    "kachhi-gujerati": "gjk",
    kadiweu: "kbc",
    kaduo: "ktp",
    kafa: "kbr",
    kagulu: "kki",
    "kaili-daa": "kzf",
    kaiwa: "kgk",
    kakataibo: "cbr",
    kako: "kkj",
    kakwa: "keo",
    "kalaallisut-greenlandic": "kl",
    kalabari: "ijn",
    "kalagan-eastern": "kqe-x-Eastern",
    "kalagan-tagakaulu": "klg",
    "kalagen-western": "kqe-x-Western",
    kalanga: "kck",
    kalanguya: "kak",
    "kalenjin-kipsigis": "kln",
    "kalmyk-oirat": "xal",
    "kalo-5": "khz",
    kamano: "kbq",
    kamasau: "kms",
    kamayo: "kyk",
    kambaata: "ktb",
    kambera: "xbr",
    kamo: "kcq",
    kamuku: "cdr",
    kanauji: "bjj",
    kandas: "kqw",
    kandawo: "gam",
    kandoozi: "cbu",
    kanembu: "kbl",
    kangri: "xnr",
    kanjari: "kft",
    kankanaey: "kne",
    "kankanay-northern": "xnn",
    kannada: "kn",
    "kanuri-yerwa": "knc",
    kanyok: "kny",
    kaonde: "kqn",
    kapampangan: "pam",
    "karai-karai": "kai",
    karakalpak: "kaa",
    karang: "kzr",
    karanga: "sn-kth",
    karbi: "mjw",
    karelian: "krl",
    "karen-pwo": "pwo",
    "karen-pwo-eastern": "kjp",
    "karen-pwo-omkoi": "pww",
    "karen-sgaw": "ksw",
    karina: "car",
    karnali: "jml",
    karo: "kxh",
    karon: "krx",
    karunsie: "xmz",
    "kasem-burkina-faso": "xsm",
    "kasem-ghana": "xsm-GH",
    kashmiri: "ks",
    kashubian: "csb",
    katab: "kcg",
    katang: "ncq",
    "katcha-kadugli-miri": "xtc",
    kathiyawadi: "gu-x-Kathiyawadi",
    "katu-eastern": "ktv",
    "kau-bru": "ria",
    kaur: "vkk",
    kayabi: "kyz",
    "kayah-li-western": "kyu",
    kayan: "pdu",
    kayapo: "txu",
    kazakh: "kk",
    keakalo: "khz",
    keapara: "khz",
    "kechwa-san-martin": "qvs",
    kedang: "ksx",
    kekchi: "kek",
    kele: "khy",
    keliko: "kbo",
    "kendayan-kanayatn": "knx",
    kenyah: "xkl",
    "kenyah-badeng": "xkl",
    kerewe: "ked",
    kerinci: "kvr",
    kermanshahi: "sdh",
    ketengban: "xte",
    khakas: "kjh",
    "khampa-eastern": "khg",
    "khandeshi-bhili": "khn",
    khandesi: "khn",
    kharia: "khr",
    khasi: "kha",
    khiamniungan: "kix",
    "khmer-central-m": "km-khm",
    "khmer-northern": "km-kxm",
    "khmer-standard": "km",
    khmu: "kjg",
    khoekhoegowab: "naq",
    khowar: "khw",
    khwarazm: "uzn",
    "kiche-cunen": "quc",
    kifuliiru: "flr",
    kikamba: "kam",
    kikongo: "kng",
    kikuro: "kui",
    kikuyu: "ki",
    kilaangi: "lag",
    kilega: "lea",
    kiluba: "lu",
    kim: "kia",
    kimbundu: "kmb",
    kimeru: "mer",
    kimpokomu: "pkb",
    kinandi: "nnb",
    "kinaray-a": "krj",
    kinga: "zga",
    kinnauri: "kfk",
    "kinnauri-pahari": "kjo",
    kintandu: "ndl",
    "kinyakyusa-tanzania": "nyy",
    kinyamulenge: "kin",
    kinyarwanda: "rw",
    kirho: "dud",
    kiribati: "gil",
    kirundi: "rn",
    kisan: "xis",
    kisanga: "sng",
    kisi: "kiz",
    "kisi-southern": "kss",
    "kissi-northern": "kqs",
    kituba: "ktu",
    kiviila: "job",
    kiwilwana: "mlk",
    kiyombe: "yom",
    koalib: "kib",
    kobo: "okc",
    "kohistani-indus": "mvy",
    "kohli-parkari": "kvx",
    koho: "kpm",
    "koita-ga": "kqi",
    "kok-borok": "trp",
    "kok-borok-bangladesh": "tpe",
    "kokoda-k-ainake": "hkk",
    kokola: "kzn",
    kolami: "kfb",
    "koli-wadiyara": "kxp",
    "kolokuma-izon": "ijc",
    kom: "bkm",
    komering: "kge",
    "komi-permyak": "koi",
    "komi-zyrian": "kpv",
    "konda-dora": "kfc",
    "kongo-san-salvador": "kwy",
    "konjo-highland": "kjk",
    konkomba: "xon",
    konni: "kma",
    "kono-sierra-leone": "kno",
    "konongo-2": "kcz",
    konso: "kxc",
    konta: "dwr",
    koorete: "kqy",
    kope: "kiw",
    koraku: "ksz",
    korean: "ko",
    "korean-north": "ko-x-North",
    "korean-sign-language": "kvk",
    koreguaje: "coe",
    korku: "kfq",
    koromfe: "kfz",
    kortha: "mai",
    korwa: "kfp",
    koti: "eko",
    kouya: "kyf",
    koya: "kff",
    "kpelle-guinea": "gkp",
    "kpelle-liberia": "xpe",
    "kreol-mauricean": "mfe",
    krio: "kri",
    krongo: "kgo",
    "kroumen-plapo": "ktj",
    "kroumen-pye": "pye",
    "kroumen-tepo": "ted",
    kru: "klu",
    kuanua: "ksd",
    kui: "kxu",
    kukele: "kez",
    kuki: "tcz",
    kukna: "kex",
    "kulango-bondoukou": "kzc",
    "kulango-bouna": "nku",
    kulung: "bbu",
    kulvi: "kfx",
    kumam: "kdi",
    kuman: "kue",
    kumauni: "kfy",
    kumyk: "kum",
    kuna: "cuk",
    kunama: "kun",
    "kuni-boazi": "kvg",
    kunimaipa: "kup",
    kuo: "xuo",
    kupia: "key",
    kupsapiiny: "kpz",
    kuranko: "knk",
    "kurdi-behdini": "kmr",
    "kurdi-hawrami": "hac",
    "kurdi-sorani": "ckb",
    "kurdi-sorani-eastern": "ckb",
    "kurdish-afrini": "kmr",
    kuria: "kuj",
    "kurmanji-cis": "kmr",
    "kurmanji-standard": "ko-kmr",
    "kurumba-jennu": "xuj",
    "kurumba-kannada": "kfi",
    kurux: "kru",
    kusaal: "kus",
    "kusaal-eastern": "kus",
    "kusaal-western": "kus",
    kuteb: "kub",
    kutia: "ort",
    kutu: "kdc",
    kuvale: "olu",
    kuvi: "kxv",
    "kuvi-odisha": "kxv",
    kuy: "kdt",
    kwaio: "kwd",
    kwamashi: "mho",
    kwamba: "rwm",
    kwangali: "kwn",
    kwangwa: "lyn",
    kwanyama: "kj",
    kwaraae: "kwf",
    kwasio: "nmg",
    kwatay: "cwt",
    kwaya: "kya",
    kwere: "cwe",
    kwese: "kws",
    kyrgyz: "ky",
    laadi: "ldi",
    laarim: "loh",
    label: "lbb",
    ladakhi: "lbj",
    lahu: "lhu",
    lak: "lbe",
    lala: "lla",
    "lalo-central": "ywt",
    lama: "las",
    lamaholot: "slp",
    lamalera: "lmr",
    lamatuka: "lmq",
    lamba: "lam",
    lambadi: "lmn",
    lambya: "lai",
    lamnso: "lns",
    "lampung-api": "ljp",
    "lampung-nyo": "abl",
    "langilan-manobo": "atd",
    "lango-south-sudan": "lno",
    "lango-uganda": "laj",
    lao: "lo",
    laro: "lro",
    lashi: "lsi",
    latvian: "lv",
    lawangan: "lbx",
    "lebanese-sign-language": "jos",
    "lebanese-syrian-arabic": "apc",
    "ledo-ija": "lew",
    "ledo-taa": "lew",
    legbo: "agb",
    lelemi: "lef",
    lendu: "led",
    lenje: "leh",
    lepcha: "lep",
    lepki: "lpe",
    "lesser-antillean-creole-french": "gcf",
    "letuama-tanimuca": "tnc",
    "levantine-turkmen": "tuk",
    levuka: "lvu",
    lewo: "lww",
    "lewo-eleng": "lwe",
    lezgi: "lez",
    "lhao-vo": "mhx",
    "lhasa-tibetan": "bo",
    "li-bendi": "lic",
    "li-qi": "lic",
    lihir: "lih",
    lik: "eip",
    lika: "lik",
    likoonl: "xon",
    "limba-tonko-sella": "lia",
    "limba-west-central": "lia",
    limbu: "lif",
    limbum: "lmp",
    lingala: "ln",
    lingao: "onb",
    lio: "ljl",
    "lipo-eastern": "lpo",
    lipovan: "rus",
    "lis-ma-ron": "cla",
    lisu: "lis",
    lithuanian: "lt",
    lobala: "loq",
    lobi: "lob",
    logo: "log",
    lokaa: "yaz",
    loko: "lok",
    lokpa: "dop",
    lolo: "llb",
    loloda: "loa",
    loma: "lom",
    lomwe: "ngl",
    longuda: "lnu",
    lopit: "lpx",
    "lorung-northern": "lbr",
    lote: "uvl",
    "lower-daga": "dgz",
    lozi: "loz",
    lubu: "lcf",
    lubwisi: "tlj",
    luchazi: "lch",
    luganda: "lg",
    lugbara: "lgg",
    lughuru: "ruf",
    lukabaras: "lkb",
    lukpa: "dop",
    lumasaba: "myx",
    lumun: "lmd",
    lunda: "lun",
    lundayeh: "lnd",
    lungga: "lga",
    luo: "luo",
    luragoli: "rag",
    "luri-luristan-province-iran": "lrc",
    lusoga: "xog",
    lutos: "ndy",
    luvale: "lue",
    luwo: "lwo",
    "luwu-tae": "rob",
    lyele: "lee",
    maanyan: "mhy",
    maasai: "mas",
    maay: "ymm",
    macedonian: "mk",
    mada: "mda",
    madi: "mhi",
    "madi-okollo": "snm",
    madura: "mad",
    mafa: "maf",
    magahi: "mag",
    "magar-eastern": "mgp",
    "magar-western": "mrd",
    magindanaon: "mdh",
    "mahasu-pahari": "bfz",
    "mai-brat": "ayz",
    mailu: "mgu",
    maithili: "mai",
    "maithili-nepal": "mai",
    maiwa: "wmm",
    majang: "mpe",
    majhi: "mjz",
    makaa: "mcp",
    makasar: "mak",
    "makhau-tanzania": "vmw",
    makhuwa: "vmw",
    makoma: "sie",
    "makonde-mozambique": "kde",
    "makonde-tanzania": "kde",
    "mal-paharia": "mkb",
    malagasy: "mg",
    "malagasy-antankarana": "mg-xmv",
    "malagasy-antesaka": "mg-tkg",
    "malagasy-northern-betsimisaraka": "mg-bmm",
    "malagasy-southern-betsimisaraka": "mg-bzc",
    "malagasy-tanosy": "mg-txy",
    "malango-teha": "mln",
    malay: "ms",
    "malay-ambonese": "ms-abs",
    "malay-bukit": "bvu",
    "malay-jambi": "jax",
    "malay-kota-bangun-kutai": "mqg",
    "malay-north-moluccan": "max",
    "malay-papuan": "ms-pmy",
    "malay-pattani": "ms-mfa",
    "malay-tenggarong-kutai": "vkt",
    malayalam: "ml",
    "malayic-dayak": "xdy",
    male: "mdy",
    malila: "mgq",
    "malinke-kenieba": "mlq",
    "malinke-kita": "mwk",
    "malkangiri-koya": "kff",
    malo: "mfx",
    maltese: "mt",
    malvi: "mup",
    "mam-central": "mam-x-Central",
    "mam-northern": "mam",
    "mam-tajumulco": "mam-x-Tajumulco",
    mamainde: "wmd",
    mamasa: "mqj",
    mambilla: "mzk",
    "mambwe-lungu": "mgr",
    mampruli: "maw",
    mamuju: "mqx",
    mamusi: "kdf",
    manado: "xmm",
    manambu: "mle",
    manda: "mgs",
    mandar: "mdr",
    mandara: "tbf",
    "mandara-cameroon": "mfi",
    "mandarin-china": "zh",
    "mandarin-taiwan": "zh-Hant-TW",
    mandeali: "mjl",
    mandinka: "mnk",
    mandja: "mzv",
    manga: "kby",
    "mangalorean-konkani": "knn",
    mangbetu: "mdj",
    manggarai: "mqy",
    "mangghuer-wuge": "mjg",
    mango: "mge",
    maninka: "emk",
    "maninka-konyanka": "mku",
    manjaku: "mfv",
    mankanya: "knf",
    mano: "mev",
    "manobo-ata": "atd",
    "manobo-dibabawon": "mbd",
    "manobo-ilianen": "mbi",
    "manobo-matigsalug": "mbt",
    "manobo-sarangani": "mbs",
    "manobo-tagabawa": "bgs",
    "manobo-western-bukidnon": "mbb",
    mansoanka: "msw",
    manyika: "mxc",
    maonan: "mmd",
    maori: "mi",
    mapudungun: "arn",
    maquiritari: "mch",
    marakwet: "enb",
    "maram-naga": "nma",
    maranao: "mrw",
    marathi: "mr",
    marba: "mpg",
    mardini: "ar-ayp",
    "marghi-central": "mrt",
    "margi-south": "mfm",
    "mari-low": "mhr",
    maria: "mrr",
    "maria-dandami": "daq",
    markweeta: "enb",
    marma: "rmz",
    maro: "liq",
    marshallese: "mh",
    marwari: "rwr",
    "marwari-northern": "mve",
    "marwari-southern": "mve",
    masalit: "mls",
    masana: "mcn",
    masbatenyo: "msb",
    "mashami-chagga": "jmc",
    mashi: "shr",
    masikoro: "msh",
    maskelynes: "klv",
    matal: "mfh",
    matengo: "mgv",
    mato: "met",
    matses: "mcf",
    matsigenka: "mcb",
    matumbi: "mgw",
    mawae: "zia",
    mawchi: "mke",
    maxakali: "mbl",
    mayan: "yua",
    mayangna: "yan",
    mayogo: "mdm",
    "mazagway-hidi": "dkx",
    mazahua: "maz",
    mazanderani: "mzn",
    "mazateco-huautla-de-jimenez": "mau",
    mba: "mfc",
    mbala: "mdp",
    mbandja: "zmz",
    mbe: "mfo",
    mbelime: "mql",
    "mbembe-cross-river": "mfn",
    "mbembe-tigon": "nza",
    mbosi: "mdw",
    mbugwe: "mgz",
    mbuko: "mqb",
    mbukushu: "mhw",
    mbula: "mbu",
    medlpa: "med",
    medumba: "byv",
    meen: "mym",
    meitei: "mni",
    mekeo: "mek",
    "mele-fila": "mxe",
    melpa: "med",
    mende: "men",
    mentawai: "mwv",
    mephaa: "tcf",
    "mephaa-de-acatapec": "tpx",
    "mephaa-de-huitzapula": "tcf",
    meqa: "mvz",
    merey: "meq",
    merwari: "wry",
    mewari: "mtr",
    "mexican-sign-language": "mfs",
    meyah: "mej",
    mgbolizhia: "gmz",
    "miao-central-mashan": "hmm",
    "miao-chuanqiandian-cluster": "cqd",
    "miao-eastern-qiandong": "hmq",
    "miao-huishui-northern": "hmi",
    "miao-northern-qiandong": "hea",
    "miao-small-flowery": "sfm",
    "miao-southern-qiandong": "hms",
    migili: "mgi",
    "miju-mishmi": "mxj",
    minangkabau: "min",
    mingrelian: "xmf",
    minianka: "myk",
    mirgan: "zrg",
    mising: "mrg",
    miskito: "miq",
    "mixe-coatlan": "mco",
    "mixe-del-istmo": "mir",
    "mixtec-amoltepec": "mbz",
    "mixtec-ayutla": "miy",
    "mixtec-magdalena-penasco": "xtm",
    "mixteco-alacatlatzala": "mim",
    "mixteco-central-juxtlahuaca": "vmc",
    "mixteco-cuquila-ocotepec": "mie",
    "mixteco-diuxi-tilantongo": "xtd",
    "mixteco-eastern": "mil",
    "mixteco-metlatonoc": "mxv-x-Metlatonoc",
    "mixteco-monte-verde": "xtn",
    "mixteco-northwest-oaxaca": "mxa",
    "mixteco-potoichan": "mim",
    "mixteco-santa-maria-apasco": "mip",
    "mixteco-silacayoapan": "mks",
    "mixteco-southern-puebla": "mit",
    "mixteco-terroro-venado": "mxv",
    miya: "mkf",
    "mizo-lushai": "lus",
    mmen: "bfm",
    "mnong-central": "cmo",
    "mnong-rlam": "mng",
    moba: "mfq",
    mochi: "old",
    modole: "mqo",
    "mofu-gudur": "mif",
    moken: "mwt",
    moksha: "mdf",
    molbog: "pwm",
    moma: "myl",
    mon: "mnw",
    "mongo-nkundu": "lol",
    "mongolian-halh": "mn",
    mongondow: "mog",
    mono: "mnh",
    moore: "mos",
    moro: "mor",
    moru: "mgd",
    mosiye: "dox",
    mouwase: "jmw",
    mpoto: "mpa",
    mpyemo: "mcx",
    mro: "cmr",
    mru: "mro",
    mualang: "mtd",
    mumuye: "mzm",
    muna: "mnb",
    munda: "unx",
    mundang: "mua",
    mundani: "mnf",
    mundari: "unr",
    "mundari-south-sudan": "mqu",
    mundu: "muh",
    munduruku: "myu",
    mungaka: "mhk",
    munukutuba: "mkw",
    muong: "mtq",
    mupun: "sur",
    "muria-eastern": "emu",
    "muria-western": "mut",
    murle: "mur",
    musgu: "mug",
    muyang: "muy",
    mwaghavul: "sur",
    mwan: "moa",
    mwani: "wmw",
    mwera: "mwe",
    "mwimbi-igoji-muthambi": "mws",
    naasioi: "nas",
    nafaanra: "nfr",
    "naga-angami": "njm",
    "naga-chang": "nbc",
    "naga-chokri": "nri",
    "naga-khezha": "nkh",
    "naga-konyak": "nbe",
    "naga-liangmai": "njn",
    "naga-lotha": "njh",
    "naga-mao": "nbi",
    "naga-rongmei": "nbu",
    "naga-sangtam": "nsa",
    "naga-sumi": "nsm",
    "naga-tangkhul": "nmf",
    "naga-yimchungru": "yim",
    "naga-zeme": "nzm",
    nagamese: "nag",
    nage: "nxe",
    nago: "nqg",
    "nahuatl-central-huasteca": "nch",
    "nahuatl-eastern-huasteca": "nhe",
    "nahuatl-isthmus-pajapan": "nhp",
    "nahuatl-michoacan": "ncl",
    "nahuatl-northern-puebla": "ncj",
    "nahuatl-orizaba": "nlv",
    "nahuatl-sierra-de-puebla": "azz",
    "nahuatl-southeast-puebla": "npl",
    "nahuatl-western-huasteca": "nhw",
    "nahuatl-zacatlan-ahuacatlan-tepetzintla": "nhi",
    nakanai: "nak",
    nalca: "nlc",
    nama: "nmx",
    "nambikuara-southern": "nab",
    nambya: "nmq",
    namiae: "nvm",
    namwanga: "mwn",
    nandeva: "tpj",
    nandi: "niq",
    nangjere: "nnc",
    napu: "npy",
    "nasu-eastern": "ywq",
    nauruan: "na",
    navaho: "nv",
    nawary: "rmt",
    nawdm: "nmz",
    naxi: "nxq",
    ndali: "ndh",
    ndamba: "ndj",
    ndau: "ndc",
    "ndebele-northern": "nd",
    "ndebele-southern": "nr",
    ndendeule: "dne",
    ndogo: "ndz",
    "ndokwa-ukwuani": "ukw",
    ndola: "ndr",
    ndrulo: "led",
    ndruna: "niy",
    ndut: "ndv",
    nembe: "ijs",
    nepali: "npi",
    nethakani: "te",
    "new-zealand-sign-language": "nzs",
    newari: "new",
    ngada: "nxg",
    ngakarimojong: "kdj",
    ngambay: "sba",
    ngamo: "nbh",
    ngas: "anc",
    ngbaka: "nga",
    ngbandi: "ngb",
    "ngbandi-ngiri": "nbw",
    ngbugu: "lnl",
    nghlawa: "kga",
    ngiemboon: "nnh",
    ngindo: "nnq",
    ngizim: "ngi",
    ngomba: "jgo",
    ngombale: "nla",
    ngombe: "ngc",
    "ngombe-north": "ngc",
    "ngombe-south": "ngc",
    ngonde: "nyy",
    ngulu: "ngp",
    nguna: "llp",
    ngungwel: "ngz",
    nias: "nia",
    "nigerian-pidgin-english": "pcm",
    nimadi: "noe",
    ninzo: "nin",
    "nisu-northern": "yiv",
    nivacle: "cag",
    njebi: "nzb",
    "nkim-nkum": "isi",
    nkoya: "nka",
    nogai: "nog",
    noiri: "noi",
    nomane: "nof",
    noon: "snf",
    noone: "nhu",
    "north-gumuz": "guk",
    "norwegian-bokmal": "no",
    "nosu-shengzha": "iii",
    "nosu-tianba": "iii",
    "nosu-yinuo": "iii",
    notsi: "ncf",
    nsenga: "nse",
    nta: "ndd",
    ntcham: "bud",
    nuer: "nus",
    numanggang: "nop",
    nung: "nut",
    "nuni-southern": "nnw",
    nupe: "nup",
    "nusa-penida": "ban",
    nyala: "nle",
    nyamboa: "nwb",
    nyamwezi: "nym",
    nyaneka: "nyk",
    nyanga: "nyj",
    nyangatom: "nnj",
    nyaturu: "rim",
    nyiramba: "nim",
    nyishi: "njz",
    nyole: "nuj",
    nyungwe: "nyu",
    nzakara: "nzk",
    nzanyi: "nja",
    nzema: "nzi",
    oadki: "odk",
    obamba: "mdt",
    "obe-nrung-ene": "afe",
    "obo-manobo": "obo",
    obolo: "ann",
    "od-rajput": "odk",
    odiya: "ory",
    ogan: "ms-pse-x-Ogan",
    ogea: "eri",
    ogoni: "ogo",
    "ojibwa-western": "ojw",
    okiek: "oki",
    "okinawan-central": "ryu",
    okpe: "oke",
    okpella: "atg",
    okrika: "okr",
    oku: "oku",
    olukwumi: "ulb",
    "olulumo-ikom": "iko",
    olunyole: "nyd",
    olutachoni: "lts",
    omi: "omi",
    "omwunra-toqura": "omw",
    oniyan: "bsc",
    ono: "ons",
    "orang-seletar": "ors",
    "oriya-adivasi": "ort",
    "oro-wari-2": "pav",
    orokaiva: "okv",
    oroko: "bdu",
    "oromo-borana-arsi-guji": "gax",
    "oromo-eastern": "hae",
    "oromo-west-central": "gaz",
    osetin: "os",
    osing: "osi",
    ososo: "oso",
    "ot-danum": "otd",
    otetela: "tll",
    "otomi-eastern": "otm",
    "otomi-mezquital": "ote",
    "otomi-western": "otq",
    otoro: "otr",
    "otuho-lotuko": "lot",
    owa: "stn",
    oyda: "oyd",
    paama: "pma",
    padoe: "pdo",
    paez: "pbb",
    pagabete: "pae",
    pagoe: "pgu",
    "pak-pak-dairi": "btd",
    palamua: "kwx",
    palauan: "pau",
    "palaung-pale": "pce",
    "palaung-rumai": "rbb",
    palembang: "mui",
    palikur: "plu",
    "pame-central": "pbs",
    pamona: "pmf",
    panare: "pbh",
    panchpargania: "tdb",
    pangasinan: "pag",
    pangwa: "pbr",
    pangwali: "pgg",
    paniya: "pcg",
    "panjabi-western": "pnb",
    pao: "blk",
    papel: "pbo",
    papiamentu: "pap",
    parakana: "pak",
    paranan: "prf",
    pardhan: "pch",
    pardhi: "pcl",
    parecis: "pab",
    pasaale: "sig",
    pasemah: "ms-pse",
    "pashto-eastern-afghan": "pbu",
    "pashto-southern": "pbt",
    "pashto-yusufzai": "pbu",
    pattae: "mqj",
    pattapu: "ptq",
    "penang-hokkien": "nan",
    pengo: "peg",
    "persian-sign-language": "psc",
    peve: "lme",
    phende: "pem",
    phom: "nph",
    piapoco: "pio",
    piaroa: "pid",
    "pidgin-cameroon": "wes",
    "pidgin-liberian": "lir",
    pijin: "pis",
    pimbwe: "piw",
    pinyin: "pny",
    pipero: "pip",
    plang: "blr",
    plautdietsch: "pdt",
    pnar: "pbv",
    pogoro: "poy",
    pohnpeian: "pon",
    poke: "pof",
    "pokomo-lower": "pkb",
    pokoot: "pko",
    polish: "pl",
    "pomeranian-brazilian": "nds",
    "pontianak-hakka": "hak",
    "popoloca-san-felipe-otlaltepec": "pow",
    "popoloca-san-juan-atzingo": "poe",
    "popoloca-san-luis-temalacayuca": "pps",
    "popoluca-sierra": "poi",
    "portuguese-brazil": "pt",
    "portuguese-mozambique": "pt-MZ",
    "portuguese-portugal": "pt-PT",
    pougouli: "pug",
    "poumai-naga": "pmx",
    powari: "pwr",
    provencal: "oci",
    psikye: "kvj",
    puinave: "pui",
    pulangiyen: "mbb",
    "punan-tubu": "puj",
    punjabi: "pa",
    purepecha: "tsz",
    "purepecha-western-highland": "pua",
    pyam: "pym",
    qanjobal: "kjb",
    qashqai: "qxq",
    qena: "alw",
    "qiang-southern": "qxs",
    "quechua-ambo-pasco": "qva",
    "quechua-ancash-conchucos-northern": "qxn",
    "quechua-ancash-conchucos-southern": "qxo",
    "quechua-ancash-huaylas": "qwh",
    "quechua-ayacucho": "quy",
    "quechua-cuzco": "quz",
    "quechua-eastern-apurimac": "qve",
    "quechua-huanuco-huallaga": "qub",
    "quechua-huanuco-huamalies-northern-dos-de-mayo": "qvh",
    "quechua-lambayeque": "quf",
    "quechua-margos-yarowilca-lauricocha": "qvm",
    "quechua-north-bolivian": "qul",
    "quechua-north-junin": "qvn",
    "quechua-panao-huanuco": "qxh",
    "quechua-south-bolivian": "quh",
    "quechua-southern-pastaza": "qup",
    "quiche-central": "quc",
    "quiche-joyabaj": "quc",
    "quiche-west-central": "quc",
    "quichua-canar-highland": "qxr",
    "quichua-highland-chimborazo": "qug",
    "quichua-imbabura-highland": "qvi",
    "quichua-pastaza": "qvz",
    "quichua-salasaca-highland": "qxl",
    "quichua-tena-lowland": "quw",
    rabha: "rah",
    rade: "rad",
    "rai-bantawa": "bap",
    "rajbangsi-india": "rjs",
    "rajbanshi-nepal": "rjs-NP",
    rakhine: "rki",
    ralte: "ral",
    rampi: "lje",
    "rana-tharu": "thr",
    "rangpuria-bangla": "rkt",
    rao: "rao",
    rathawi: "rtw",
    ravula: "yea",
    rawa: "rwo",
    rawang: "raw",
    rejang: "rej",
    rendille: "rel",
    reshe: "res",
    "reunion-creole-french": "rcf",
    ribeirinho: "por",
    rigwe: "iri",
    rikbaktsa: "rkb",
    "rinconada-bikol": "bto",
    "roglai-northern": "rog",
    rohingya: "rhg",
    "romani-balkan": "rmn",
    "romani-balkan-romania": "rmn",
    "romani-caldarasi": "rmy",
    "romani-carpathian": "rmc",
    "romani-kalderash-western": "rmy-kal",
    "romani-sinte": "rmo",
    romanian: "ro",
    "romanian-sign-language": "rms",
    romblomanon: "rol",
    ronga: "rng",
    roviana: "rug",
    rufumbira: "rw",
    rukuba: "ruk",
    rumu: "klq",
    runyankole: "nyn",
    runyoro: "nyo",
    "ruruuli-runyala": "ruc",
    russian: "ru",
    "russian-sign-language": "rsl",
    ruund: "rnd",
    ruwila: "rwl",
    saa: "apb",
    "saafi-saafi": "sav",
    sabaot: "spy",
    sabu: "hvn",
    sadani: "sck",
    "sadri-oraon": "sdr",
    safwa: "sbk",
    "saho-eritrea": "ssy",
    sahu: "saj",
    "sakalava-analalava": "skg-x-Analalava",
    "sakalava-besalampy": "skg",
    sakata: "skt",
    salar: "slr",
    saluan: "loe",
    "sama-bangingi": "sse",
    "sama-central": "sml",
    "sama-mum": "ndi",
    "sama-southern": "ssb",
    "samarkand-tajik": "tg-x-Samarkand",
    sambal: "xsb",
    sambalpuri: "spv",
    samburu: "saq",
    samia: "lsm",
    samo: "sbd",
    samoan: "sm",
    "san-andres-islander-creole": "icr",
    "san-chi": "mlc",
    sanga: "xsn",
    sanggau: "scg",
    sangihe: "sxn",
    sangil: "snl",
    sango: "sg",
    sangu: "sbp",
    "sani-3": "ysn",
    sansi: "ssi",
    "santali-india": "sat",
    "santhali-nepal": "sat",
    sanuma: "xsu",
    sapo: "krn",
    saptari: "thq",
    sara: "mwm",
    saraiki: "skr",
    "saraiki-megwhal": "skr",
    saramaccan: "srm",
    "sardinian-logudorese": "src",
    "sarlahi-tharu": "thq",
    sasak: "sas",
    "satere-mawe": "mav",
    "saura-2": "srb",
    saurashtra: "saz",
    "sauria-paharia": "mjt",
    saya: "say",
    sedoa: "tvw",
    sehwi: "sfw",
    "seko-padang": "skx",
    selaru: "slu",
    selayar: "sly",
    semelai: "sza",
    sena: "seh",
    "sena-malawi": "swk",
    sengele: "szg",
    sengwer: "enb",
    "senoufo-cebaara": "sef",
    "senoufo-djimini": "dyi",
    "senoufo-nyarafolo": "sev",
    "senoufo-supyire": "spp",
    "senoufo-tagbana": "tgw",
    serawai: "ms-pse-x-Serawai",
    serbian: "sr",
    "serere-sine": "srr",
    "seselwa-creole": "crs",
    shambala: "ksb",
    shan: "shn",
    shanghainese: "wuu",
    shanjo: "toi",
    sharchogpa: "tsj",
    "shawi-chayahuita": "cbt",
    shekhawati: "swv",
    shekkacho: "moy",
    sheko: "she",
    sherbro: "bun",
    sherpa: "xsr",
    shilluk: "shk",
    shimaore: "swb",
    shina: "scl",
    "shina-kohistani": "plk",
    "shipibo-conibo": "shp",
    shona: "sn",
    shuar: "jiv",
    shughni: "sgh",
    shui: "swi",
    siang: "sya",
    "siar-lak": "sjr",
    sidaama: "sid",
    sidamo: "sid",
    siddi: "kan",
    "sihanaka-2": "plt",
    sika: "ski",
    sikkiligar: "sle",
    silte: "stv",
    sinasina: "sst",
    sinaugoro: "snc",
    sindhi: "sd",
    "sindhi-bhil": "sbn",
    "sindhi-sansi": "ssi",
    sinhala: "si",
    sirmauri: "srx",
    "sisaala-tumulung": "sil",
    sissala: "sld",
    siswati: "ss",
    slavey: "xsl",
    slovak: "sk",
    slovenian: "sl",
    soli: "sby",
    somali: "so",
    "somba-siawari": "bmu",
    "songai-timbuktu": "khq",
    songe: "sop",
    "songhay-gao": "ses",
    soninke: "snk",
    sora: "srb",
    "sotho-northern": "nso",
    "sotho-southern": "st",
    sougb: "mnx",
    "south-gumuz": "guk",
    "southern-gondi-adilabad": "wsg",
    "southern-nisu": "nsd",
    "spanish-castilian": "es-ES",
    "spanish-latin-american": "es",
    "sranan-tongo": "srn",
    suau: "swp",
    suba: "sxb",
    "suba-simbiti": "ssc",
    "subanen-eastern": "sfe",
    "subanen-northern": "stb",
    "subanon-western": "suc",
    suena: "sue",
    suku: "sub",
    sukuma: "suk",
    sukur: "syk",
    sula: "szn",
    sumbawa: "smw",
    sunda: "su",
    "sunda-alus": "sun",
    "sundanese-banten": "sun",
    sunuwar: "suz",
    suodi: "ii",
    surgujia: "sgj",
    "suri-tirmaga-chai": "suq",
    surjapuri: "sjp",
    surui: "sru",
    suryoyo: "tru",
    susu: "sus",
    "swahili-congo": "sw-swc",
    "swahili-kenya": "sw-swh-KE",
    "swahili-tanzania": "sw",
    swedish: "sv",
    sylheti: "syl",
    sylhetti: "syl",
    syriac: "syc",
    taa: "pmf",
    tabaru: "tby",
    tabassaran: "tab",
    tacawit: "shy",
    tachelhit: "shi",
    tado: "klw",
    tagalog: "fil",
    "tagbanwa-calamian": "tbk",
    tahitian: "ty",
    "tai-dam": "blt",
    "tai-don": "twh",
    "tai-lue": "khb",
    "tai-nua": "tdd",
    tairora: "tbg",
    taita: "dav",
    tajik: "tg",
    tajpuriya: "rjs",
    takia: "tbc",
    "takuu-nakumanu": "nho",
    takwane: "tke",
    tal: "tal",
    "talaandig-manobo": "bkd",
    talaud: "tld",
    "tali-2": "kbn",
    talysh: "tly",
    "tamajeq-tahoua": "ttq",
    "tamang-eastern": "taj",
    "tamang-western": "tdg",
    "tamasheq-kidal": "taq",
    "tamazight-central-atlas": "tzm",
    tambee: "mzq",
    tamil: "ta",
    tampulma: "tpm",
    tangale: "tan",
    tangoa: "tgp",
    "tangsa-kimsing": "nst",
    "tangshang-shecyu-cyamcyang": "nst",
    tanjijili: "uji",
    "tanna-north": "tnn",
    "tanna-southwest": "nwi",
    "tarahumara-baja": "tac",
    "tarahumara-central": "tar",
    tarifit: "rif",
    "tarifit-arabic-based-script": "rif",
    "tarifit-latin-based-script": "rif",
    tarok: "yer",
    tasahlit: "kab",
    "tat-azeri": "ttt",
    "tat-juhuri": "jdt",
    tatar: "tt",
    tausug: "tsg",
    taveta: "tvs",
    tawala: "tbo",
    "tawbuid-eastern": "bnj",
    tboli: "tbl",
    "tchien-krahn": "kqo",
    tchumbuli: "bqa",
    tehit: "kps",
    tehl: "mtl",
    "teke-central": "TEC",
    "teke-eboo": "ebo",
    "teke-tege": "teg",
    telugu: "te",
    tem: "kdh",
    tembarissa: "ktb",
    temi: "soz",
    tengger: "tes",
    tennet: "tex",
    teochew: "nan-x-Teochew",
    "tepehuan-northern": "ntp",
    tera: "ttr",
    ternate: "tft",
    "teso-kenyan": "teo",
    "tetun-belu": "tet",
    "tetun-dili": "tdt",
    thai: "th",
    "thai-northern": "th-nod",
    "thai-southern": "th-sou",
    thami: "thf",
    tharaka: "thk",
    "tharu-dangaura": "thl",
    "tharu-kathariya": "tkt",
    themne: "tem",
    "thradhri-kohli": "kxp",
    thur: "lth",
    ticuna: "tca",
    "tidung-southern": "itd",
    tigak: "tgc",
    tigre: "tig",
    "tigrinya-eritrea": "ti",
    "tigrinya-ethiopia": "ti-ER",
    "tigwahanon-manobo": "mbt",
    "tinonanon-manobo": "obo",
    tira: "tic",
    tiriki: "ida",
    tiruray: "tiy",
    tiv: "tiv",
    "tiwa-northern": "twf",
    tiyaa: "tyy",
    "tlapaneco-de-tlacoapa": "tpl",
    tlicho: "dgr",
    toabaita: "mlu",
    toba: "tob",
    "toba-maskoy": "tmf",
    tobelo: "tlb",
    tojolabal: "toj",
    "tok-pisin": "tpi",
    tolaki: "lbw",
    "toli-gbe-2": "guw",
    toma: "tod",
    tombulu: "tom",
    tomini: "txm",
    tondano: "tdn",
    tonga: "toi",
    "tonga-malawi": "tog",
    "tonga-zambezi": "toi",
    tongan: "to",
    tonsawang: "tnw",
    tonsea: "txs",
    tontemboan: "tnt",
    "tontemboan-makelai": "tnt",
    toposa: "toq",
    toraja: "sda",
    torwali: "trw",
    "totonac-coyutla": "toc",
    "totonac-papantla": "top",
    "totonaca-sierra": "tos",
    toura: "neb",
    "traditional-japanese": "jpn",
    trinitario: "trn",
    "trique-san-juan-copala": "trc",
    trukese: "chk",
    tsamakko: "tsb",
    tshiluba: "lua",
    tsikimba: "kdl",
    tsimane: "cas",
    tsimanex: "cas",
    tsimihety: "xmw",
    tsishingini: "tsw",
    tsogo: "tsv",
    tsonga: "ts",
    tsuvadi: "tvd",
    tswa: "tsc",
    tswana: "tn",
    "tu-huzhu": "mjg",
    tugen: "tuy",
    tula: "tul",
    tulu: "tcy",
    tumbuka: "tum",
    tunia: "tug",
    tunjung: "tjg",
    tupuri: "tui",
    turka: "tuz",
    turkana: "tuv",
    turkish: "tr",
    turkmen: "tk",
    tuvin: "tyv",
    tuyuca: "tue",
    twi: "tw",
    tyap: "kcg",
    "tzeltal-bachajon": "tzh-x-Bachajon",
    "tzeltal-oxchuc": "tzh",
    "tzeltal-tenango": "tzh-x-Tenango",
    "tzeltal-tenejapa": "tzh",
    "tzotzil-chamula": "tzo",
    "tzutujil-eastern": "tzj",
    "tzutujil-western": "tzj",
    uare: "ksj",
    udmurt: "udm",
    uduk: "udu",
    ukaan: "kcf",
    ukrainian: "uk",
    "ukrainian-sign-language": "ukl",
    ukue: "uku",
    "umajamnon-manobo": "msm",
    umbundu: "umb",
    "uneme-north": "une",
    "uneme-south": "une",
    urat: "urt",
    urdu: "ur",
    "urdu-hoda": "urd",
    "urdu-indian": "urd",
    urhobo: "urh",
    urim: "uri",
    "uripiv-wala-rano-atchin": "upv",
    "urubu-kaapor": "urb",
    usarufa: "usa",
    ushoi: "usi",
    uspanteco: "usp",
    "ut-hun": "uth",
    utukwang: "afe",
    "uud-danum": "otd",
    uyghur: "ug",
    "uyghur-central-asia": "uig",
    "uzbek-northern": "uzn",
    "uzbek-southern": "uzs",
    vagla: "vag",
    vai: "vai",
    vaiphei: "vap",
    vajjika: "mai",
    vale: "vae",
    vanuma: "vau",
    "varhadi-nagpuri": "vah",
    varli: "vav",
    vasavi: "vas",
    "vasavi-kolche": "vas",
    vasui: "tpz",
    venda: "ve",
    verre: "ver",
    vidunda: "vid",
    vietnamese: "vi",
    "vietnamese-northern": "vi-x-Northern",
    vili: "vif",
    visualvernacular: "ase",
    vitu: "wiv",
    "vunjo-chagga": "vun",
    vwanji: "wbi",
    "wa-vo": "wbm",
    waama: "wwa",
    waata: "ssn",
    waddar: "wbq",
    wagdi: "wbr",
    waghiri: "vaa",
    waja: "wja",
    wakatobi: "bhq",
    wala: "lgl",
    wali: "wlx",
    wambon: "wms",
    wamey: "cou",
    wampis: "hub",
    "wana-taa": "pmf",
    waneci: "wne",
    "wanga-luhya": "lwg",
    waorani: "auc",
    warao: "wba",
    "waray-waray": "war",
    warji: "wji",
    waropen: "wrp",
    wasa: "wss",
    waskia: "wsk",
    watakataui: "wtk",
    waumeo: "noa",
    waura: "wau",
    "wayampi-amapari": "oym-x-Amapari",
    "wayampi-oiapoque": "oym-x-Oiapoque",
    wayuu: "guc",
    "we-northern": "wob",
    welsh: "cy",
    "weri-2": "wer",
    "western-carib": "car",
    "western-garame": "acz",
    "western-lipo": "lpo",
    "western-poqomchi": "poh",
    wewewa: "wew",
    "wichi-lhamtes-guisnay": "mzh",
    winye: "kst",
    wolane: "wle",
    wolaytta: "wal",
    wolio: "wlo",
    wolof: "wo",
    wondama: "wad",
    worodougou: "jud",
    wumvu: "wum",
    xaasongaxango: "kao",
    xamtanga: "xan",
    xavante: "xav",
    xhosa: "xh",
    xiang: "hsn",
    xinulajgsipij: "tqt",
    xun: "xuu",
    yabem: "jae",
    yaka: "axk",
    "yaka-central-african-republic": "axk",
    "yaka-d-r-c": "yaf",
    "yaka-drcongo": "yaf",
    yakan: "yka",
    yakha: "ybh",
    yakoma: "yky",
    yakpa: "bjo",
    "yakpa-1": "bjo",
    yakut: "sah",
    yala: "yba",
    yalunka: "yal",
    yamba: "yam",
    yamdena: "jmd",
    yandang: "ynq",
    yanesha: "ame",
    "yanomami-ninam": "shb",
    yanomamo: "guu",
    yao: "yao",
    "yao-baiku-naogelao": "bwx",
    "yao-iu-mien": "ium",
    "yao-tanzania": "yao",
    yapese: "yap",
    yaqui: "yaq",
    yareba: "yrb",
    yawa: "yva",
    yemba: "ybb",
    yemsa: "jnj",
    yerukula: "yeu",
    yiddish: "ydd",
    yine: "pib",
    yinzebi: "nzb",
    yom: "pil",
    yonggom: "yon",
    yoruba: "yo",
    yucuna: "ycn",
    yukpa: "yup",
    yungur: "yun",
    yuracare: "yuz",
    ywom: "gek",
    zabana: "kji",
    zaiwa: "atb",
    zanaki: "zak",
    "zande-drc": "zne",
    "zande-south-sudan": "zne-Sd",
    "zapotec-san-pedro-quiatoni": "zpf",
    "zapotec-tabaa": "zat",
    "zapoteco-de-san-juan-comaltepec": "zpc",
    "zapoteco-isthmus": "zai",
    "zapoteco-mitla": "zaw",
    "zapoteco-san-juan-guelavia": "zab",
    "zapoteco-sierra-de-juarez": "zaa",
    "zapoteco-southern-rincon": "zsr",
    "zapoteco-western-pochutla": "ztp",
    "zapoteco-yalalag": "zpu",
    zaramo: "zaj",
    zarma: "dje",
    zayse: "zay",
    "zhuang-central-hongshuihe": "zch",
    "zhuang-dejing": "zyg",
    "zhuang-guibian": "zgn",
    "zhuang-liujiang": "zlj",
    "zhuang-minz": "zgm",
    "zhuang-nong": "zhn",
    "zhuang-northern-hongshuihe": "zch",
    "zhuang-northern-yongbei": "zyb",
    "zhuang-qiubei": "zqe",
    "zhuang-yongnan": "zyn",
    "zhuang-youjiang": "zyj",
    "zhuang-zuojiang": "zzj",
    zia: "zia",
    zigula: "ziw",
    zimba: "zmb",
    zing: "mzm-x-Zing",
    zinza: "zin",
    zo: "zom",
    "zokam-tedim": "ctd",
    "zoque-francisco-leon": "zos",
    zul: "plj",
    zulu: "zu",
    zuni: "zun",
  })
